document.addEventListener("DOMContentLoaded", function () {
  class YgMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.style.display = "flex";
    }
    connectedCallback() {
      const megaMenuList = document.querySelectorAll(".yg-mega-menu")

      megaMenuList.forEach(function (megaMenu) {
        const collectionList = megaMenu.querySelectorAll('.yg-menu-hover')
        const collectionContentList = megaMenu.querySelectorAll('.yg-menu-block');
        collectionList[0].classList.add("active");
        collectionContentList[0].style.display = "flex";
        itemMouseenter(collectionList, collectionContentList)

        document.addEventListener('dropdown-closed', () => {
          collectionList.forEach(function (collection) {
            collection.classList.remove("active")
          })
          collectionList[0].classList.add("active")

          collectionContentList.forEach(function (collectionContent) {
            collectionContent.style.display = "none"
          })
          collectionContentList[0].style.display = "flex"
        })
      })

      function itemMouseenter(collectionList, collectionContentList) {
        collectionList.forEach(function (collection, index) {
          collection.addEventListener("mouseenter", function () {
            collectionList.forEach(function (collection) {
              collection.classList.remove("active")
            })
            collection.classList.add("active")

            collectionContentList.forEach(function (collectionContent) {
              collectionContent.style.display = "none"
            })
            collectionContentList[index].style.display = "flex"
          })
        })
      }
    }
  }

  if(!window.customElements.get("yg-mega-menu")) {
    window.customElements.define("yg-mega-menu", YgMegaMenu);
  }
})